<template>
  <div class='TabelaBairro'>
    <div class="cont">
      <input-reg
      @update:model-value="newValue => getBairro(newValue)"
      text="CEP"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      :Mask="['#####-###']"
      />
      <input-reg
      :value="bairro"
      text="Bairro"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      disabled
      />
    </div>
    <div class="cont">
      <input-reg
      :value="valor"
      @update:model-value="newValue => valor = newValue"
      text="Valor (R$)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <input-reg
      :value="gratisapartir"
      @update:model-value="newValue => gratisapartir = newValue"
      text="Grátis a partir de (R$)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
    </div>
    <div class="cont">
      <input-reg
      :value="valormin"
      @update:model-value="newValue => valormin = newValue"
      text="Valor mínimo (R$)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
    </div>
    <div class="cont-btn">
      <button @click="_CreateFreteBairro($data)">Adicionar</button>
    </div>
    <tabela-bairro-view/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import TabelaBairroView from './TabelaBairroView'
export default {
  name: 'TabelaBairro',
  components: { InputReg, TabelaBairroView },
  data () {
    return {
      bairro: '',
      valor: '',
      valormin: '',
      gratisapartir: ''
    }
  },
  computed: {
    ...mapGetters(['Frete'])
  },
  methods: {
    ...mapActions(['changeFrete', 'getApiCep', '_CreateFreteBairro']),
    getBairro (cep) {
      if (cep.length === 9) {
        this.getApiCep(cep.replace('-', ''))
          .then(data => {
            this.bairro = data.bairro
          })
      } else {
        this.bairro = ''
      }
    }
  }
}
</script>

<style scoped>
.TabelaBairro {
}

.cont {
  display: flex;
}

.cont-btn {
  width: 98%;
  display: flex;
  justify-content: end;
  padding-top: 1.5%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  padding: 0.8%;
  font-size: 12px;
  cursor: pointer
}
</style>
